import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
// import Layout from '../../component/layout'
import { toastify } from '../../../../utils/toast'
import { makeRequest } from '../../../../utils/makeRequest'
// import { getItem } from '../../../../utils/localStorage'
import { deleteFAQ, getFAQs } from '../../../../utils/urls'

const Faq = () => {
    const [FAQs, setFAQs] = useState([]);

    // Add this function at the top of your component
    function linkifyText(text) {
        if (!text) return '';
        const urlRegex = /(https?:\/\/[^\s]+)/g;

        // Split the text by URLs
        const parts = text.split(urlRegex);
        const matches = text.match(urlRegex) || [];

        // If no links, return the original text
        if (matches.length === 0) return text;

        // Combine text and links
        return parts.map((part, i) => {
            // Check if this part matches a URL
            if (matches.includes(part)) {
                return (
                    <a key={i} href={part} target="_blank" rel="noopener noreferrer">
                        {part}
                    </a>
                );
            }
            return part;
        });
    }


    const fetchFaqs = async () => {
        try {

            const response = await makeRequest(getFAQs, 'GET', {});
            if (response.success) {
                setFAQs(response.data)
            }
            else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, 'error');
        }
    }




    const handleDelete = async (faqId) => {
        try {
            const response = await makeRequest(deleteFAQ + '/' + faqId, 'GET')
            console.log("FAQID", faqId)
            if (response.success) {
                toastify('FAQ deleted successfully', 'success')
                fetchFaqs();
            }
            else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, 'error');
        }
    }

    useEffect(() => {
        fetchFaqs();
    }, [])

    return (
        // <Layout>
        <div>
            {/* <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/app/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Visitor & Access Management</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>FAQs</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> */}

            <nav className="navbar navbar-light bg-light shadow-sm px-3 d-flex justify-content-center">
                <div className="container d-flex align-items-center justify-content-between w-100">
                    <a className="navbar-brand fw-bold" href="/">LFRA App</a>
                    <div className="d-flex justify-content-center">
                        <a className="mx-3 text-decoration-none text-dark fw-bold" href="/">Home</a>
                        <a className="text-decoration-none text-dark fw-bold" href="/faq">FAQ</a>
                    </div>
                    <div className="invisible navbar-brand">
                        {/* <!-- This empty div helps balance the navbar --> */}
                    </div>
                </div>
            </nav>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>FAQs</h5>
                                </div>

                                <div className='card-body'>
                                    <div className="row">
                                        <div className="col-lg-12 col-xxl-12">
                                            <div className="card">
                                                <div className="card-body position-relative">
                                                    <div className="row">
                                                        <div className="col-md-3 col-xs-12 mb-3">
                                                            {/* <input
                                                                className="form-control"
                                                                placeholder="Search here"
                                                                value={searchTerm}
                                                                onChange={(e) => { handleInputSearch(e.target.value) }}
                                                            /> */}
                                                        </div>

                                                        <div className="col-md-9 col-xs-12 mb-3">
                                                            {/* <div style={{ float: 'right' }}>
                                                                <button className='btn btn-primary' onClick={() => navigate('/facility/visitor_access_management/faq/add_faq')}>Add FAQ</button>
                                                                &nbsp;
                                                            </div> */}
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-md-12'>
                                                            <div className="accordion" id="faqAccordion">
                                                                {FAQs.length > 0 ? FAQs.map((faq, index) => (
                                                                    <div className="accordion-item" key={faq.id}>
                                                                        <h2 className="accordion-header d-flex justify-content-between align-items-center" id={`heading${index}`}>
                                                                            <button
                                                                                className="accordion-button collapsed"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target={`#collapse${index}`}
                                                                                aria-expanded="false"
                                                                                aria-controls={`collapse${index}`}
                                                                            >
                                                                                <b>{faq.question}</b>
                                                                            </button>
                                                                            {/* <div className="action-buttons ms-2 d-flex">
                                                                                <Link
                                                                                    to={`/facility/visitor_access_management/faq/edit_faq/${faq._id}`}
                                                                                    className="btn btn-sm btn-outline-primary me-2"
                                                                                >
                                                                                    Edit
                                                                                </Link>
                                                                                <button type="button" className="btn btn-sm btn-outline-danger me-1 mb-1" onClick={() => handleDelete(faq._id)}>Delete</button>
                                                                            </div> */}
                                                                        </h2>
                                                                        <div
                                                                            id={`collapse${index}`}
                                                                            className="accordion-collapse collapse"
                                                                            aria-labelledby={`heading${index}`}
                                                                            data-bs-parent="#faqAccordion"
                                                                        >
                                                                            <div className="accordion-body">
                                                                                {linkifyText(faq.answer)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )) : (
                                                                    <p>No FAQs available.</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>




                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        // </Layout>
    )
}

export default Faq